<template>
  <div class="table-detail">
    <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
    <div class="row">
      <div class="col-xs-12 col-sm-2">
        <div class="text-center">
          <button class="btn btn-info edit-bottom" type="button" @click="handleEdit(item.pCodeId)">編集</button>
        </div>
      </div>
      <div class="col-xs-12 col-sm-10">
        <div id="accordion" class="accordion-style1 panel-group">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a class="accordion-toggle collapsed" data-toggle="collapse" v-bind:href="randomAcountHref(item.pCodeId)" aria-expanded="false" @click="loadData()">
                  <i data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right" class="bigger-110 ace-icon fa fa-angle-right"></i>
                  &nbsp;個人コード詳細
                </a>
              </h4>
            </div>
            <div class="panel-collapse collapse" :id="randomAcountClass(item.pCodeId)">
              <div class="panel-body">
                <div class="profile-user-info profile-user-info-striped">
                  <div class="profile-info-row">
                    <div class="profile-info-name">個人コード</div>
                    <div class="profile-info-value">
                      <span>{{item.pCodeId}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ユーザーID</div>
                    <div class="profile-info-value">
                      <span class="editable"><a class="link" @click="viewUser(item.userId)">{{item.userId}}</a></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ユーザー名</div>
                    <div class="profile-info-value">
                      <span class="editable">{{userInfo.userName}}/{{userInfo.userFurigana}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">コード種別</div>
                    <div class="profile-info-value">
                      <span>{{item.type}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ステータス</div>
                    <div class="profile-info-value">
                      <span v-if="item.isValid">有効</span>
                      <span v-else >無効</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">登録日</div>
                    <div class="profile-info-value">
                      {{ converDate(item.registered) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'

export default {
  props: ['item', 'userId'],
  data () {
    return {
      loading: false,
      userInfo: {
        userName: '',
        userFurigana: ''
      }
    }
  },
  methods: {
    loadData () {
      var vm = this
      this.getUserInfo(vm.userId)
    },
    removeSpecialSymboy (text) {
      return text.replace(/[^a-z0-9\s]/gi, '-').replace(/[_\s]/g, '-')
    },
    randomAcountClass (classname) {
      return 'pcode' + this.removeSpecialSymboy(classname)
    },
    randomAcountHref (classname) {
      return '#pcode' + this.removeSpecialSymboy(classname)
    },
    getUserInfo (userId) {
      this.$http.get(Config.USERS_LIST_API + '?userId=' + encodeURIComponent(userId))
        .then(response => {
          this.userInfo.userName = response.body.users[0].name
          this.userInfo.userFurigana = response.body.users[0].furigana
        })
        .catch(error => {
          this.userInfo.userName = ''
          this.userInfo.userFurigana = ''
          console.log(error)
        })
    },
    handleEdit (id) {
      this.$router.push({name: 'pcodeedit', query: { id: id }})
    },
    viewUser (id) {
      let routeData = this.$router.resolve({name: 'useredit', query: {id: id}})
      window.open(routeData.href, '_blank')
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>
<style>
  .table-detail .profile-info-name{
    width: 195px
  }
  .device{
    margin-top: 50px;
    border-top: 2px solid #ccc
  }
  .table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle.collapsed{
    font-size: 18px
  }
  .table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle{
    font-size: 18px
  }
</style>



// WEBPACK FOOTER //
// src/views/pcode/PcodeDetail.vue